import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Announcement } from 'src/app/classes/announcement';

@Component({
  selector: 'app-announcement',
  templateUrl: './announcement.component.html',
  styleUrls: ['./announcement.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AnnouncementComponent implements OnInit {
  @Input() announcement = new Announcement()
  
  constructor(public router: Router,
    public activeModal: NgbActiveModal) { }

  ngOnInit() {
    // Auto-dismiss the modal if dismiss_after is set and greater than 0
    if (this.announcement.dismiss_after && this.announcement.dismiss_after > 0) {
      setTimeout(() => {
        this.activeModal.dismiss();
      }, this.announcement.dismiss_after * 1000); // Convert seconds to milliseconds
    }
  }
}
